import { useEffect, useState } from "react";
import axios from "axios";
import { TEAM_EXTRAS } from "@/data/teamExtras";

let cache = null;

const withExtras = (teams) =>
  teams.map((t) => {
    const extras = TEAM_EXTRAS[t.slug] || {};
    return { ...t, name: extras.name || t.name };
  });

export const useTeams = () => {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    if (!cache) {
      cache = axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/teams`)
        .then((r) => (Array.isArray(r.data) ? withExtras(r.data) : []))
        .catch(() => []);
    }
    let mounted = true;
    cache.then((data) => {
      if (mounted) setTeams(data);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return teams;
};
